(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    if (!this.header) return;

    this.headerBounds = {};
    this.currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);

    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    /*
      Mobile filter Apply can cause a synthetic upward scroll when the
      drawer unlocks/closes. Without this guard the sticky-header logic
      interprets that as a genuine user scroll-up and reveals the header
      in the middle of the collection page.
    */
    this.onMobileFilterApply = (event) => {
      const applyButton = event.target.closest('[data-mobile-facets-apply]');
      if (!applyButton) return;

      this.preventReveal = true;

      const syncScrollPosition = () => {
        this.currentScrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(syncScrollPosition);
      });

      window.clearTimeout(this.mobileFilterApplyTimer);

      this.mobileFilterApplyTimer = window.setTimeout(() => {
        syncScrollPosition();
        this.preventReveal = false;
      }, 450);
    };

    this.addEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      { passive: true }
    );

    document.addEventListener(
      'click',
      this.onMobileFilterApply,
      true
    );

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener(
      'preventHeaderReveal',
      this.hideHeaderOnScrollUp
    );

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

    document.removeEventListener(
      'click',
      this.onMobileFilterApply,
      true
    );

    window.clearTimeout(this.mobileFilterApplyTimer);
  }

  createObserver() {
    if (!this.header) return;

    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0]) {
        this.headerBounds = entries[0].intersectionRect;
      }

      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    if (!this.header || !this.headerBounds) return;

    const scrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    /*
      If predictive search is open, leave the header exactly where it is.
      This prevents the sticky-header scroll behaviour from interfering
      with the active search UI.
    */
    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (this.preventHide) {
        this.currentScrollTop = scrollTop;
        return;
      }

      requestAnimationFrame(this.hide.bind(this));

    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        requestAnimationFrame(this.hide.bind(this));
      }

    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.header) return;

    this.header.classList.add(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky'
    );

    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (!this.header) return;

    this.header.classList.add(
      'shopify-section-header-sticky',
      'animate'
    );

    this.header.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  reset() {
    if (!this.header) return;

    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  closeMenuDisclosure() {
    if (!this.header) return;

    this.disclosures =
      this.disclosures ||
      this.header.querySelectorAll('header-menu');

    this.disclosures.forEach((disclosure) => {
      if (typeof disclosure.close === 'function') {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    if (!this.header) return;

    this.searchModal =
      this.searchModal ||
      this.header.querySelector('details-modal');

    if (
      this.searchModal &&
      typeof this.searchModal.close === 'function'
    ) {
      this.searchModal.close(false);
    }
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
